import React from "react";
import { Link } from "react-router-dom";

const PaymentCancel = () => {
  return (
    <div className="flex justify-center items-center min-h-[60vh] p-8">
      <div className="card max-w-xl w-full text-center border-t-4 border-red-500">
        <div className="inline-flex justify-center items-center w-20 h-20 bg-red-500 text-white text-4xl rounded-full mb-6">
          ×
        </div>
        <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-white">
          Payment Canceled
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Your payment was canceled and you have not been charged.
        </p>

        <div className="text-left mb-8">
          <h3 className="font-semibold mb-4 text-gray-800 dark:text-white">
            What would you like to do?
          </h3>
          <ul className="list-disc pl-6 text-gray-500 dark:text-gray-400 space-y-2">
            <li>Try the payment again</li>
            <li>Choose a different payment method</li>
            <li>Select a different credit package</li>
          </ul>
        </div>

        <div className="flex gap-4 justify-center">
          <Link to="/buy-credits" className="btn btn-primary">
            Try Again
          </Link>
          <Link to="/" className="btn btn-secondary">
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
